import { Currency, CurrencyPeriod, Money } from 'API';
import { intComma } from 'humanize-plus';
import React from 'react';
import { resolvers } from 'shared/enums';

interface Props {
  period?: boolean;
  value?: Money | null;
}

const CurrencyDisplay: React.FC<Props> = ({ period, value }: Props) => {
  if (value?.amount == null) {
    return null;
  }

  const [units, cents] = value.amount?.toString().split('.');

  // Check if the units amount is negative
  const isNegativeAmount = units.startsWith('-');

  // Remove the negative sign from units if units value is negative
  const unitsValue = isNegativeAmount ? units.slice(1) : units;

  return (
    <>
      {isNegativeAmount && '-'}
      {resolvers.Currency((value as Money).currency as Currency)}
      {intComma(parseInt(unitsValue, 10))}
      {cents && `.${cents.padEnd(2, '0').slice(0, 2)}`}
      {period && ` ${resolvers.CurrencyPeriod(
        (value as Money).period || CurrencyPeriod.ANNUAL,
      )}`}
    </>
  );
};

export default CurrencyDisplay;
